import { useState, useEffect } from 'react';

const isClient = typeof window === 'object';
function getSize() {
  return {
    width: isClient
      ? document.documentElement.clientWidth || window.innerWidth
      : undefined,
    height: isClient
      ? document.documentElement.clientHeight || window.innerHeight
      : undefined,
  };
}

// Hook
export const useWindowSize = () => {
  const [windowSize, setWindowSize] = useState(getSize);

  useEffect(() => {
    if (!isClient) {
      return false;
    }

    function handleResize() {
      const size = getSize();
      setWindowSize({ ...size });
    }

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return windowSize;
};
